import { render, staticRenderFns } from "./SFXBrochure.vue?vue&type=template&id=e248fe40&scoped=true"
import script from "./SFXBrochure.vue?vue&type=script&lang=js"
export * from "./SFXBrochure.vue?vue&type=script&lang=js"
import style0 from "./SFXBrochure.vue?vue&type=style&index=0&id=e248fe40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e248fe40",
  null
  
)

export default component.exports